import { Persona, PersonaSize, PersonaPresence } from '@fluentui/react/lib/Persona';
import { bindActionCreators } from "redux";
import { returnType } from "../../Utilities/ReturnType";
import { connect } from "react-redux";
import { GlobalAutoHealing } from "../../Interface/IGlobalAutoHealing";
import { convertUtcToPst } from "../../Utilities/CommonFunction";
import { useLocation } from 'react-router-dom';

import { Stack, IconButton, Text } from '@fluentui/react';
import "./ContentOpportunityPane.css";
import { useEffect, useState } from 'react';

const actionCreators = {};

type DispatchProps = typeof actionCreators;

const mapStateToProps = (state: GlobalAutoHealing) => ({
    reviewContent: state.reviewContent,
    replaceContent: state.replaceContent,
    radioSelected: state.radioSelected
});

const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;


function SafeHtmlLink({ htmlString }) {
  const isLink = /^<a\s/i.test(htmlString.trim());

    const handleClick = (e) => {
        e.preventDefault();
        let match = htmlString.match(/href=["']([^"']+)["']/i);
        if (match && match[1]) {
            var href = window.location.href;
            let url = match[1];
            if (href.includes('apps/brokenlinkfixer')) {
                if (!/^https?:\/\//i.test(url)) {
                    url = 'https://internal.evergreen.microsoft.com/' + url.replace(/^\//, '');
                }
            }
            window.open(url, "_blank");
        }
    };

  if (isLink) {
    return (
      <span
        style={{ cursor: "pointer", color: "#0078d4", textDecoration: "underline" }}
        onClick={handleClick}
        dangerouslySetInnerHTML={{ __html: htmlString }}
      />
    );
  } else {
    return <span dangerouslySetInnerHTML={{ __html: htmlString }} />;
  }
}

function ContentOpportunityPane(props: StoreProps & DispatchProps) {

    const pathArr = useLocation().pathname.split('/')
    const fixerPath = pathArr[pathArr.length-1]
    

    // Content Opportunities ObservableValue
    const [collapsedContentCorpus, setCollapsedContentCorpus] = useState<boolean>(true)

    // Ticket Management ObservableValue
    const [collapsedTicket, setCollapsedTicket] = useState<boolean>(true)

    // Microsoft Content Baseline ObservableValue
    const [collapsedBaseline, setCollapsedBaseline] = useState<boolean>(true)


    /**
     * Collapse or expand the Content Opportunities
     */
    function onCollapseContentCorpusClicked() {
        // collapsedContentCorpus.value = !collapsedContentCorpus.value;
        setCollapsedContentCorpus(!collapsedContentCorpus)
    };

    /**
     * Collapse or expand the Ticket Management
     */
    function onCollapseTicketClicked() {
        // collapsedTicket.value = !collapsedTicket.value;
        setCollapsedTicket(!collapsedTicket)
    };

    /**
     * Collapse or expand the Microsoft Content Baseline
     */
    function onCollapseBaselineClicked() {
        // collapsedBaseline.value = !collapsedBaseline.value;
        setCollapsedBaseline(!collapsedBaseline)
    };

    useEffect(() => {

    }, [props.radioSelected])
    /**
     * Render the reviewers
     * @returns 
     */
    function renderReviews() {
        console.log("radioSelected",props.radioSelected)
        if (props.reviewContent === null) {
            return null;
        }

        if (props?.reviewContent?.RequiredReviewers ||
            props?.reviewContent?.OptionalReviewers ||
            props?.reviewContent?.Manager) {
            return (<ul>
                {
                    (props?.reviewContent?.RequiredReviewers && !props?.reviewContent?.RequiredReviewers.startsWith('Content Automation Service Account')) && <li>Required: <br />
                        <p>
                            <Persona
                                text={props?.reviewContent?.RequiredReviewers}
                                size={PersonaSize.size24}
                                presence={PersonaPresence.online}
                                imageAlt="Annie Lindqvist, status is online"
                            />
                        </p>
                    </li>
                }
                {
                    ((props?.reviewContent?.OptionalAlias !== props?.reviewContent?.RequiredAlias) && props?.reviewContent?.OptionalReviewers && !props?.reviewContent?.OptionalReviewers.startsWith('Content Automation Service Account')) && <li>Optional:  <br />
                        <p>
                            <Persona
                                text={props?.reviewContent?.OptionalReviewers}
                                size={PersonaSize.size24}
                                presence={PersonaPresence.online}
                                imageAlt="Annie Lindqvist, status is online"
                            />
                        </p>
                    </li>
                }
                {
                    (props?.reviewContent?.Manager && !props?.reviewContent?.Manager.startsWith('Content Automation Service Account')) && <li>Manager:  <br />
                        <p>
                            <Persona
                                text={props?.reviewContent?.Manager}
                                size={PersonaSize.size24}
                                presence={PersonaPresence.online}
                                imageAlt="Annie Lindqvist, status is online"
                            />
                        </p>
                    </li>
                }
            </ul>)
        }

        return null
    }

    const getReplacedReview = () => {
        let replaceContentReviewList = props.replaceContent? [...props.replaceContent.ReplacementList, ...props.replaceContent.NavReplacementList, ...props.replaceContent.MetaReplacementList]: []
        if(props.radioSelected === "Replace" && replaceContentReviewList?.length > 0) {
            if(replaceContentReviewList.length > 3 ) {
                replaceContentReviewList = replaceContentReviewList.slice(0,3)
            }
            return (
                <span>
                    <h4>Automated change summary</h4>
                    <div>
                        {props.reviewContent?.AutoChangeSummary}
                        <ul>
                            {replaceContentReviewList.map((item, index) => (
                                <li key={index}>
                                    <div style={{ backgroundColor: "#EBF1DC", display: "inline-block" }} dangerouslySetInnerHTML={{ __html: item.AutoChangeSummaryHtml }}>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </span>
            )
        }
        if(props.reviewContent?.AutoChangeSummaryHtml && props.reviewContent.AutoChangeSummaryHtml?.length > 0) {
            return (
                <span>
                    <h4>Automated change summary</h4>
                    <div>
                        {props.reviewContent?.AutoChangeSummary}
                        <ul>
                            {props.reviewContent.AutoChangeSummaryHtml.map((item, index) => (
                            <li key={index}>
                                <div style={{ backgroundColor: "#EBF1DC", display: "inline-block" }} dangerouslySetInnerHTML={{ __html: item }}>
                                </div>
                            </li>
                            ))}
                        </ul>
                    </div>
                </span>
            )
        }
        return null
    }

    return (
        <div className='markerPane'>
            {/* <Card
                className="flex-grow"
                collapsible={true}
                collapsed={collapsedContentCorpus}
                onCollapseClick={onCollapseContentCorpusClicked}
                titleProps={{
                    text: "Content Opportunities",
                    ariaLevel: 1,
                }}
            > */}
            <Stack tokens={{ childrenGap: 8 }} className="customCardPane">
                <Stack style={{ marginLeft: "-5px" }} horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                    <IconButton
                        iconProps={{ iconName: collapsedContentCorpus ? 'ChevronDown' : 'ChevronRight' }}
                        onClick={onCollapseContentCorpusClicked}
                        title="Expand or collapse"
                        ariaLabel="Expand or collapse"
                        styles={{
                            root: {
                                color: '#000',
                                fontSize: 12,
                                marginTop: 2,
                            },
                            icon: {
                                color: '#000',
                                fontSize: 12,
                            },
                        }}
                    />
                    <Text variant="large" styles={{ root: { fontWeight: 700 } }}>
                        Content Opportunities
                    </Text>
                </Stack>

                {
                    collapsedContentCorpus ?
                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    <a className='articleUrl' href={props?.reviewContent?.Link}>{props?.reviewContent?.PageTitle}</a>
                                    {
                                        (props.reviewContent &&
                                            props.reviewContent.ContentQualityIssuesHtml &&
                                            props.reviewContent.ContentQualityIssuesHtml.length > 0) ?
                                            <span>
                                                <h4>Content quality issue</h4>
                                                <div>
                                                    {props?.reviewContent?.ContentQualityIssues}
                                                    <ul>
                                                        {
                                                            props.reviewContent.ContentQualityIssuesHtml.map((item, index) => {
                                                                return <li key={index}>
                                                                    <div style={{ backgroundColor: "#FFCCCB", display: "inline-block" }}>
                                                                        <SafeHtmlLink htmlString={item} />
                                                                    </div>
                                                                </li>
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </span>
                                            : null
                                    }
                                    {getReplacedReview()}
                                    <span>
                                        <h4>Automated change pending your approval</h4>
                                        <div>See the details at the right side.</div>
                                    </span>
                                    <span>
                                        <h4>About this content request</h4>
                                        <ul>
                                            {
                                                props.reviewContent?.AboutThisContentRequest?.map((item, index) => {
                                                    return <li key={index}>{item}</li>
                                                })
                                            }
                                        </ul>
                                    </span>
                                </div>
                            </div>
                        </div> : null
                }
            </Stack>

            {/* <Card
                className="flex-grow"
                collapsible={true}
                collapsed={collapsedTicket}
                onCollapseClick={onCollapseTicketClicked}
                titleProps={{
                    text: "Ticket Management",
                    ariaLevel: 1,
                }}
            > */}
            <Stack tokens={{ childrenGap: 8 }} className="customCardPane">
                <Stack style={{ marginLeft: "-5px" }} horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                    <IconButton
                        iconProps={{ iconName: collapsedTicket ? 'ChevronDown' : 'ChevronRight' }}
                        onClick={onCollapseTicketClicked}
                        title="Expand or collapse"
                        ariaLabel="Expand or collapse"
                        styles={{
                            root: {
                                color: '#000',
                                fontSize: 12,
                                marginTop: 2,
                            },
                            icon: {
                                color: '#000',
                                fontSize: 12,
                            },
                        }}
                    />
                    <Text variant="large" styles={{ root: { fontWeight: 700 } }}>
                        Ticket Management
                    </Text>
                </Stack>

                {
                    collapsedTicket ?
                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    <h3>Organization</h3>
                                    {
                                        props.reviewContent?.Organization &&
                                        <ul>
                                            <li>{props.reviewContent?.Organization}</li>
                                        </ul>
                                    }
                                    <h3>Reviewers</h3>
                                    {
                                        renderReviews()
                                    }
                                    {
                                        props.reviewContent?.TicketId &&
                                        <>
                                            <h3>Work item</h3>
                                            <ul>
                                                <li><a href={props.reviewContent?.TicketUrl}>{props.reviewContent?.TicketTitle}</a></li>
                                                <li>Due Date: {convertUtcToPst(props.reviewContent?.DueDate)}</li>
                                            </ul>
                                        </>
                                    }

                                </div>
                            </div>
                        </div> : null
                }
            </Stack>

            {/* <Card
                className="flex-grow"
                collapsible={true}
                collapsed={collapsedBaseline}
                onCollapseClick={onCollapseBaselineClicked}
                titleProps={{
                    text: "Microsoft Content Baseline",
                    ariaLevel: 1,
                }}
            > */}
            <Stack tokens={{ childrenGap: 8 }} className="customCardPane">
                <Stack style={{ marginLeft: "-5px" }} horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                    <IconButton
                        iconProps={{ iconName: collapsedBaseline ? 'ChevronDown' : 'ChevronRight' }}
                        onClick={onCollapseBaselineClicked}
                        title="Expand or collapse"
                        ariaLabel="Expand or collapse"
                        styles={{
                            root: {
                                color: '#000',
                                fontSize: 12,
                                marginTop: 2,
                            },
                            icon: {
                                color: '#000',
                                fontSize: 12,
                            },
                        }}
                    />
                    <Text variant="large" styles={{ root: { fontWeight: 700 } }}>
                        Microsoft Content Baseline
                    </Text>
                </Stack>

                {
                    collapsedBaseline ?
                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    <h3>Internal support article governance best practices</h3>
                                    <ul>
                                        <li dangerouslySetInnerHTML={{ __html: props.reviewContent?.InternalSupportArticleGovernanceBestPracticesHtml }}></li>
                                    </ul>
                                    <span>
                                        <h3>Remediation guidance</h3>
                                        <ul>
                                            <li dangerouslySetInnerHTML={{ __html: props.reviewContent?.RemediationGuidanceHtml }}></li>
                                        </ul>
                                    </span>
                                </div>
                            </div>
                        </div> : null
                }
            </Stack>
        </div>
    );
};

export default connect<StoreProps, DispatchProps>(
    mapStateToProps,
    bindActionCreators.bind({}, actionCreators)
)(ContentOpportunityPane);
